import Chart from "react-apexcharts";
import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import {
  Card,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
  Button,
} from "reactstrap";
import { api } from "../../_services/api.service";
import { LinearProgressIndicator } from "../../Components/LinearProgressIndicator";
import colors, { getColor } from "../../_helpers/colors";
import exceptionHandler from "../../_helpers/exceptionHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDollarSign,
  faDotCircle,
  faStar,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";
import ReactApexChart from "react-apexcharts";
const DecisionResultsModal = ({ showModal, toggleModal, selectedUserData }) => {
  let [criteriaList, setCriteriaList] = useState([]);
  let [scenario, setScenario] = useState(null);
  let [partnerScenario, setPartnerScenario] = useState(null);
  let [isLoading, setIsLoading] = useState(false);

  let [alternatives, setAlternatives] = useState([]);
  let [highestRatingAlt, setHighestRatingAlt] = useState(null);
  let [bestValueAlt, setBestValueAlt] = useState(null);

  let [optionsSeries, setOptionsSeries] = useState(null);
  let optionsBase = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      type: "string",
      categories: [],
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  let [pieChartOptions, setPieChartOptions] = useState({
    chart: {
      id: "pie",
    },
    labels: [],
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            width: 350,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });
  let [pieChartSeries, setPieChartSeries] = useState([]);
  let [pieChartOptionsSeries, setPieChartOptionsSeries] = useState(null);
  let [isPieChartLoading, setIsPieChartLoading] = useState(false);

  let [scatterSeries, setScatterSeries] = useState([]);
  let scatterOptions = {
    chart: {
      height: 350,
      type: "scatter",
      zoom: {
        enabled: true,
        type: "xy",
      },
    },
    xaxis: {
      tickAmount: 10,
      labels: {
        formatter: function (val) {
          return formatMoney(val);
        },
      },
    },
    yaxis: {
      tickAmount: 7,
    },
  };

  useEffect(() => {
    if (
      showModal &&
      selectedUserData != undefined &&
      selectedUserData != null
    ) {
      setIsLoading(true);
      setIsPieChartLoading(true);
      api.getScenarioByIdFull(selectedUserData.scenarioId).then((data) => {
        setScenario(data);
        api.getPartnerScenarioById(data.partnerScenarioID).then((ps) => {
          setPartnerScenario(ps);
        });
        loadObjectives();
        loadAlternativeScores(data);
        loadStackedBarChart();
        loadQuadrantChart();
      }, exceptionHandler.handleError);
    }
  }, [showModal]);

  const loadObjectives = () => {
    api
      .getObjectivesByScenario_UserScore(
        selectedUserData.scenarioId,
        selectedUserData.userId
      )
      .then((data) => {
        data.forEach((element, idx) => {
          element.backgroundColor = getColor(idx);
        });
        setCriteriaList(
          data.sort(function (a, b) {
            return b - a;
          })
        );
        setIsLoading(false);
        populatePieChart(data);
      }, exceptionHandler.handleError);
  };

  const loadAlternativeScores = (scenario) => {
    api
      .getAlternativeScoresByScenario_UserScores(
        selectedUserData.scenarioId,
        selectedUserData.userId
      )
      .then((data) => {
        data.forEach((e) => {
          e.backgroundColor = colors.DODGER_BLUE;
        });
        setHighestAndBestAlts(data);
        setAlternatives(
          data.map((x) => {
            if (x.alternativeID == scenario.selectedAlternativeID) {
              x.isSelected = true;
            }
            return x;
          })
        );
        setIsLoading(false);
      }, exceptionHandler.handleError);
  };

  const setHighestAndBestAlts = (alts) => {
    if (alts !== undefined && alts.length > 0) {
      let maxAlt = alts.reduce((prev, curr) =>
        prev.alternativeScore > curr.alternativeScore ? prev : curr
      );
      setHighestRatingAlt(maxAlt);
      let altsWithCost = alts.filter((x) => x.cost > 0);
      if (altsWithCost.length > 0) {
        let bestAlt = altsWithCost.reduce((prev, curr) =>
          prev.alternativeScore / prev.cost > curr.alternativeScore / curr.cost
            ? prev
            : curr
        );
        setBestValueAlt(bestAlt);
      }
    }
  };

  const populatePieChart = (data) => {
    let options = {
      chart: {
        id: "pie",
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val, otherData) => {
            return `$${val}`;
          },
          title: {
            formatter: function (seriesName) {
              return `${seriesName}: `;
            },
          },
        },
      },
      labels: [],
      responsive: [
        {
          breakpoint: 600,
          options: {
            chart: {
              width: 350,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };
    let series = [];
    for (var i = 0; i < data.length; i++) {
      options.labels.push(data[i].objectiveName);
      series.push(data[i].evFinal);
    }

    setPieChartOptionsSeries({ options, series });

    setIsPieChartLoading(false);
  };

  const loadStackedBarChart = () => {
    api
      .getStackedBarChartByScenario_UserScores(
        selectedUserData.scenarioId,
        selectedUserData.userId
      )
      .then(stackedBarChartCallback, exceptionHandler.handleError);
  };

  const stackedBarChartCallback = (data) => {
    let newseries = [];
    let categories = [];

    if (data !== undefined && data !== null) {
      data.altItems.forEach((alt) => {
        if (alt !== null) {
          categories.push(alt.alternativeName);
          alt.objItems.forEach((item) => {
            if (item !== null) {
              let o = newseries.find((x) => x.name == item.objectiveName);
              if (o == undefined) {
                o = {
                  name: item.objectiveName,
                  data: [],
                };

                newseries.push(o);
              }
              o.data.push(+item.objectiveScore.toFixed(1));
            }
          });
        }
      });

      let opt = JSON.parse(JSON.stringify(optionsBase));
      opt.xaxis.categories = categories;

      setOptionsSeries({
        series: newseries,
        options: opt,
      });
    }
  };

  const loadQuadrantChart = () => {
    api
      .getQuadrantChartByScenario_UserScores(
        selectedUserData.scenarioId,
        selectedUserData.userId
      )
      .then(quadrantChartCallback, exceptionHandler.handleError);
  };

  const quadrantChartCallback = (data) => {
    if (data !== undefined && data !== null) {
      let seriesLst = [];
      data.altItems.forEach((d) => {
        seriesLst.push({
          name: d.alternativeName,
          data: [[d.cost, d.alternativeScore]],
        });
      });

      setScatterSeries(seriesLst);
    }
  };

  const formatMoney = (number) => {
    if (number === null || number === undefined) return "$--";
    return parseInt(number)
      .toLocaleString("en-US", { style: "currency", currency: "USD" })
      .split(".")[0];
  };

  const clearAndToggleModal = () => {
    toggleModal();
    setScenario(null);
    setOptionsSeries([]);
    setScatterSeries([]);
    setPieChartOptionsSeries(null);
    setAlternatives([]);
  };

  return !selectedUserData ? null : (
    <Modal
      size="lg"
      isOpen={showModal}
      toggle={clearAndToggleModal}
      backdrop="static"
    >
      <ModalHeader toggle={clearAndToggleModal}>
        {scenario !== null && scenario !== undefined && scenario.scenarioName}{" "}
        Results
      </ModalHeader>

      <div style={{ margin: "30px", marginTop: "10px" }}>
        {isLoading && <Loader style={{}} type="ball-pulse" active />}
        {!isLoading && scenario !== undefined && scenario !== null && (
          <div className="custom-card">
            <h5>Decision Model</h5>
            {criteriaList != undefined && criteriaList != null && (
              <div>
                {criteriaList.map((crit) => (
                  <div key={crit.objectiveID.toString()}>
                    <p>
                      <b>{crit.objectiveName}</b> - {crit.evFinal}%
                    </p>
                    <LinearProgressIndicator
                      textStyle={{
                        color: colors.DODGER_BLUE,
                        fontWeight: "bold",
                      }}
                      max={100}
                      current={crit.evFinal}
                      isOpac={true}
                    />
                  </div>
                ))}
                {criteriaList.length > 0 && (
                  <div>
                    <>
                      {scenario.cr < 0.1 && (
                        <p style={{ fontSize: 16, marginTop: 10 }}>
                          Note: Your inputs were very consistent cross the
                          criteria, you should feel very confident about the
                          model!
                        </p>
                      )}
                      {scenario.cr > 0.25 && (
                        <p style={{ fontSize: 16, marginTop: 10 }}>
                          Note: The judgments that you provided were not highly
                          consistent. You can either go back and re-evaluate the
                          criteria or proceed to the next step to score
                          alternatives.
                        </p>
                      )}
                    </>

                    {isPieChartLoading && (
                      <Loader style={{}} type="ball-pulse" active />
                    )}
                    {!isPieChartLoading && pieChartOptionsSeries.length > 0 && (
                      <ReactApexChart
                        options={pieChartOptionsSeries.options}
                        series={pieChartOptionsSeries.series}
                        type="pie"
                        width="100%"
                        height="500"
                      />
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {optionsSeries !== undefined &&
          optionsSeries !== null &&
          optionsSeries.length > 0 && (
            <div>
              <h5>Alternative Analysis</h5>
              <ReactApexChart
                options={optionsSeries.options}
                series={optionsSeries.series}
                type="bar"
                height={350}
              />
            </div>
          )}

        <div>
          {alternatives.map((alt) => (
            <div
              key={alt.alternativeID.toString()}
              style={{
                fontSize: 18,
                display: "flex",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={alt.isSelected ? faTrophy : faDotCircle}
                color={alt.isSelected ? colors.GOLD : colors.PRIMARY_TEXT_COLOR}
                style={{ width: "20px", height: "20px" }}
                //   onClick={() => handleAlternativePressed(alt)}
              />
              <div style={{ marginLeft: "15px", width: "100%" }}>
                <p>
                  <b>{alt.alternativeName}</b> - {alt.alternativeScore}%
                </p>
                <LinearProgressIndicator
                  textStyle={{
                    color: colors.DODGER_BLUE,
                    fontWeight: "bold",
                  }}
                  max={100}
                  current={alt.alternativeScore}
                  isOpac={true}
                />
              </div>
            </div>
          ))}
        </div>
        {scenario != undefined &&
          scenario != null &&
          scenario.useCost &&
          scatterSeries != undefined &&
          scatterSeries.length > 0 && (
            <div className="custom-card" style={{ marginTop: "10px" }}>
              <h5>Cost vs. Benefit</h5>
              <Row xs="2" sm="2" md="2">
                <Col md="1" xs="1" sm="1" style={{ paddingLeft: 30 }}>
                  <Row>
                    <div className="scatter-chart-labels">High Benefit</div>
                  </Row>
                  <Row style={{ height: "55%" }} />
                  <Row>
                    <div className="scatter-chart-labels">Low Benefit</div>
                  </Row>
                </Col>
                <Col md="10" xs="10" sm="10">
                  <ReactApexChart
                    options={scatterOptions}
                    series={scatterSeries}
                    type="scatter"
                    height={350}
                  />
                  <Row>
                    <Col md="6">
                      <div
                        className="scatter-chart-labels"
                        style={{ paddingLeft: 25 }}
                      >
                        Low Cost
                      </div>
                    </Col>
                    <Col md="6">
                      <div
                        className="scatter-chart-labels"
                        style={{ textAlign: "right" }}
                      >
                        High Cost
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
      </div>
    </Modal>
  );
};

export default DecisionResultsModal;
